import {
  READY_CHANGE_STORE_SEND_MAIL,
  REQUEST_SEND_MAIL,
  RESPONSE_SEND_MAIL,
  REQUEST_SEND_MAIL_FAILURE,
  REQUEST_GET_RESTORE_DATA,
  RESPONSE_GET_RESTORE_DATA,
  REQUEST_GET_RESTORE_DATA_FAILURE,
  REQUEST_RESTORE_PASSWORD,
  RESPONSE_RESTORE_PASSWORD,
  REQUEST_RESTORE_PASSWORD_FAILURE,
} from "../actions/restoreActions";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  sendEmailDataState: states.NOT_REQUESTED,
  getRestoreDataState: states.NOT_REQUESTED,
  restoreItems: {},
  email: null,
  errors: null,
};

const restoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case READY_CHANGE_STORE_SEND_MAIL: {
      const { name, value } = action.payload;
      const restoreItems = Object.assign({}, state.restoreItems);

      restoreItems[name] = value;

      return Object.assign({}, state, {
        sendEmailDataState: states.NOT_REQUESTED,
        restoreItems: restoreItems,
      });
    }

    case REQUEST_SEND_MAIL:
      return Object.assign({}, state, {
        sendEmailDataState: states.REQUEST,
        errors: null,
      });
    case RESPONSE_SEND_MAIL:
      return Object.assign({}, state, {
        sendEmailDataState: states.READY,
      });
    case REQUEST_SEND_MAIL_FAILURE:
      return Object.assign({}, state, {
        sendEmailDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_GET_RESTORE_DATA:
      return Object.assign({}, state, {
        getRestoreDataState: states.REQUEST,
        errors: null,
      });
    case RESPONSE_GET_RESTORE_DATA:
      return Object.assign({}, state, {
        getRestoreDataState: states.READY,
        email: action.data.email,
      });
    case REQUEST_GET_RESTORE_DATA_FAILURE:
      return Object.assign({}, state, {
        getRestoreDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_RESTORE_PASSWORD:
      return Object.assign({}, state, {
        dataState: states.REQUEST,
        errors: null,
      });
    case RESPONSE_RESTORE_PASSWORD:
      return Object.assign({}, state, {
        dataState: states.READY,
      });
    case REQUEST_RESTORE_PASSWORD_FAILURE:
      return Object.assign({}, state, {
        dataState: states.FAILURE,
        errors: action.errors,
      });

    default:
      return state;
  }
};

export default restoreReducer;
